<template>
    <div class="feedback">
        <div class="top">
            <span>意见反馈</span>
        </div>
        <div class="main bg-fff">
            <div class="textChoice">
                <span class="text"><span class="target">*</span>请选择问题发生的场景：</span>
                <Select v-model="choicedList" style="width:110px; text-align: left;">
                    <Option v-for="(item, index) in listData" :value="item.id" :key="index">{{ item.name }}</Option>
                </Select>
            </div>
            <div class="textSetInput">
                <span class="text"><span class="target">*</span>填写问题发生的内容：<span v-if="errorMessage.desc" style="color:#E14B5D;">({{errorMessage.desc}})</span></span>
                <textarea class="userTextarea" maxlength="200" @input="descInput" v-model="desc"></textarea>
                <div class="textNum">{{remnant}}/200</div>
            </div>
            <div class="imgUpload">
                <div class="imgShow" v-if="imgUploadData.length > 0">
                    <div class="item-imgShow" @mouseenter="mouseenterHandle(index)"  @mouseleave="mouseleaveHandle(index)" :key="index" v-for="(item, index) in imgUploadData">
                        <img :src="imgBaseUrl + item[0].key" alt="">
                        <span class="delete" :class="showIndex === index ? 'deleteShow': ''" @click="deleteHandle(index)">
                            删除
                        </span>
                    </div>
                </div>
                <div class="upload-con" v-show="imgUploadData.length <= 3 && uploadProgress === 0">
                    <my-upload
                            :format="['jpg','jpeg','png']"
                            :maxSize="5120"
                            :type="1"
                            @success="handleSuccess"
                            @uploadError="handleUploadError"
                            @formatError="handleFormatError"
                            @maxSizeError="handleMaxSizeError"
                            @progress="handleProgress"
                    >
                        <div slot="style" class="uploadButton">
                            <i class="iconfont icon-plus-m"></i>
                        </div>
                    </my-upload>
                </div>

                <div class="upload-con" v-if="uploadProgress > 0">
                    <div class="uploadButton">
                        <img style="margin-top: 14px;" src="../../../images/Rolling.gif" alt="">
                    </div>
                </div>

            </div>
            <div class="contentPh">
                <span class="text">联系电话：</span>
                <input type="number" v-model="mobilePhone" placeholder="选填，便于我们与您联系" maxlength="15">
                <span class="text" v-if="errorMessage.mobilePhone" style="color:#E14B5D;">({{errorMessage.mobilePhone}})</span>
            </div>
            <div class="descrpe">
                <span class="text"><span class="target">*</span>您的反馈意见一经采纳将获得10个恐龙蛋作为奖励</span>
            </div>
            <div class="bottomButton">
                <button @click="submitHandle">立即提交</button>
            </div>
        </div>
    </div>
</template>
<script>
    import api from '../../../api'
    import myUpload from '../../common/myUpload.vue';
    import validator from '../account/validator';
    import config from '../../../config/config'
    const reg_phone = validator.reg_phone;
    export default {
        data() {
            return {
                imgBaseUrl:api.common.imgBaseUrl,
                questionType: {},
                errorMessage: {
                    desc: '' ,
                    mobilePhone: ''
                },
                mobilePhone:'',
                choicedList: '',
                desc: '',
                remnant: 0,
                imgUploadData: [],
                imgUploadId:[],
                listData: [],
                uploadProgress: 0,
                showIndex:''
            }
        },
        components:{
            myUpload
        },
        methods: {
            getListChioced(){
                api.questions.select_list()
                    .then(res => {
                        this.choicedList = res[0].id;
                        this.listData = res;
                    })
            },
            descInput(){
               this.remnant = this.desc.length;
            },
            mouseenterHandle(index){
                this.showIndex = index;
            },
            mouseleaveHandle(index){
                this.showIndex = '';
            },
            deleteHandle(index){
                this.imgUploadData.splice(index, 1);
            },
            handleSuccess(data){
                this.uploadProgress = 0;
                this.imgUploadData.push(data.data);
                this.imgUploadId.push(data.data[0].id)
            },

            handleUploadError(){
                this.uploadProgress = 0;
                this.$Message.error('上传失败,请重新上传');
            },
            handleFormatError(){
                this.uploadProgress = 0;
                this.$Message.error('请选择 jpg,jpeg 或 png 格式的文件');
            },
            handleMaxSizeError(){
                this.uploadProgress = 0;
                this.$Message.error('请选择小于 5M 的图片');
            },
            handleProgress(progress){
                this.uploadProgress = progress;
            },

            submitHandle(){
                this.errorMessage.desc = '';
                this.errorMessage.mobilePhone = '';
                if(!this.desc){
                    this.errorMessage.desc = '请填写问题描述'
                    return false
                }
                if(this.mobilePhone){
                    if(!reg_phone.test(this.mobilePhone)){
                        this.errorMessage.mobilePhone = '请填写正确的电话号码';
                        return false
                    }
                }
                let params = {
                    userFeedbackSceneId: this.choicedList,
                    problemDetail: this.desc,
                    mobilePhone: this.mobilePhone,
                    fileIds: this.imgUploadId
                }
                api.questions.users_feedback(params)
                    .then(res => {
                        this.$router.push({name:'myFeedbackSuccess'})
                    })
            }
        },
        watch: {

        },
        created(){
            this.getListChioced();
        }
    }
</script>
<style scoped type="text/scss" lang="scss">
    .feedback {
        margin-top: -1px;
        .main {
            width: 974px;
            font-size: 14px;
            float: left;
            color: #353838;
            padding: 65px 40px;
            padding-bottom: 200px;
            line-height: 26px;
            letter-spacing: 1px;
            .textChoice{
                width: 100%;
                margin-bottom: 30px;
                .text{
                    font-size: 14px;
                    color: #171A1A;
                    .target{
                        vertical-align: middle;
                        color:#E14B5D;
                    }
                }
            }
            .textSetInput{
                width: 100%;
                margin-bottom: 30px;
                .text{
                    font-size: 14px;
                    color: #171A1A;
                    .target{
                        vertical-align: middle;
                        color:#E14B5D;
                    }
                }
                .userTextarea{
                    width: 740px;
                    height: 140px;
                    padding: 10px;
                    border: 1px solid #C8CCCC;
                    border-radius: 4px;
                    margin-top: 19px;
                }
                .textNum{
                    width: 740px;
                    text-align: right;
                    font-size: 14px;
                    color: #6C6F70;
                }
            }
            .imgUpload{
                width: 100%;
                margin-bottom: 34px;
                margin-top: -20px;
                .imgShow{
                    display: inline-block;
                    /*width: 392px;*/
                    vertical-align: middle;
                    .item-imgShow{
                        display: inline-block;
                        width: 78px;
                        height: 78px;
                        position: relative;
                        overflow: hidden;
                        margin-right: 20px;
                        vertical-align: middle;
                        float: left;
                        img{
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                        .delete{
                            visibility: hidden;
                            cursor: pointer;
                            position: absolute;
                            display: inline-block;
                            width: 100%;
                            height: 30px;
                            background: rgba(108,111,112, 0.8);
                            color:#fff;
                            line-height: 30px;
                            text-align: center;
                            bottom:0px;
                            left: 0px;
                        }
                        .deleteShow{
                            visibility: visible;
                        }
                    }
                }
                .upload-con{
                    display: inline-block;
                    width: 80px;
                    height: 80px;
                    vertical-align: middle;
                    cursor: pointer;
                    .uploadButton{
                        display: inline-block;
                        width: 80px;
                        height: 80px;
                        text-align: center;
                        line-height: 80px;
                        border: 1px solid #DCE0E0;
                        vertical-align: middle;
                        .icon-plus-m{
                            font-size: 36px;
                            color:#A2A2A8;
                        }
                    }
                    &:hover{
                        opacity: 0.8;
                    }
                }

            }
            .contentPh{
                width: 100%;
                margin-bottom: 30px;
                .text{
                    font-size: 14px;
                    color: #171A1A;
                }
                > input{
                    width: 180px;
                    height: 32px;
                    padding: 0 10px;
                    border: 1px solid #C8CCCC;
                    border-radius: 4px;
                    vertical-align: middle;
                    font-size: 12px;
                    color: #6C6F70;
                }
            }
            .descrpe{
                width: 100%;
                margin-bottom: 80px;
                .text{
                    font-size: 14px;
                    color: #171A1A;
                    .target{
                        vertical-align: middle;
                        color:#E14B5D;
                    }
                }
            }
            .bottomButton{
                width: 100%;
                text-align: center;
                >button{
                    width: 145px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    background: #308697;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #FFFFFF;
                    &:hover{
                        opacity: 0.8;
                    }
                }
            }
        }
        .top {
            border-bottom: 2px solid #F2F4F5;
            span {
                font-size: 20px;
                color: #353838;
                padding: 0 40px;
            }
        }
    }
</style>
